import React from "react";
import { Icon } from "antd";

export default ({ lbl, validated = false }) => (
  <div className="f-18 title-row">
    <div className={validated ? "validated number" : "title number"}>{lbl}</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/steps/Title.js